import { tableOptionsToFirstPage } from '@/store/modules/StateUtil';

export const corporationIndexState = {
    namespaced: true,
    state: {
        filterIncludeDeleted: false,
        tableOptions: {
            page: 1,
            itemsPerPage: 30,
            sortBy: ['name'],
            sortDesc: [true],
            mustSort: true,
            multiSort: false,
        },
    },
    mutations: {
        setFilterIncludeDeleted(state, filterIncludeDeleted) {
            state.filterIncludeDeleted = filterIncludeDeleted;
            state.tableOptions = tableOptionsToFirstPage(state);
        },
        setTableOptions(state, tableOptions) {
            state.tableOptions = tableOptions;
        },
    },
    getters: {
        filterIncludeDeleted: state => {
            return state.filterIncludeDeleted;
        },
        tableOptions: state => {
            return state.tableOptions;
        },
    },
};
